// Pings each region's health endpoint (`GET /`) to pick the fastest in proxy mode. EU and US front
// the same robots, so lower latency is strictly better. Returns { EU, US } medians in ms, or
// Infinity for a region whose every sample failed.
import nateFetch from '@/helpers/nate_fetch';

async function pingOnce(base, timeoutMs) {
  const start = performance.now();
  await nateFetch(`${base}/?ping=${start}`, { cache: 'no-store', signal: AbortSignal.timeout(timeoutMs) });
  return performance.now() - start;
}

async function pingMedian(base, samples, timeoutMs) {
  if (!base) return Infinity;

  // Tolerate individual slow/failed samples (cold start, momentary load); only Infinity if all fail.
  const rtts = [];
  for (let i = 0; i < samples; i++) {
    try {
      rtts.push(await pingOnce(base, timeoutMs));
    } catch {
      // ignore this sample
    }
  }

  if (rtts.length === 0) return Infinity;

  rtts.sort((a, b) => a - b);
  return rtts[Math.floor(rtts.length / 2)];
}

export default async function measureRegionLatency(baseUrls, { samples = 3, timeoutMs = 5000 } = {}) {
  const [EU, US] = await Promise.all([
    pingMedian(baseUrls?.EU, samples, timeoutMs),
    pingMedian(baseUrls?.US, samples, timeoutMs),
  ]);

  return { EU, US };
}
